module.exports = __webpack_public_path__ + "static/007163-b5912818ca59203c2d4eeef4aba43897.jpg";